"use strict";
/**
 * @module Services.TopicUpdate
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Data type for a CREATE_UPDATE_STREAM request.
 */
var CreateUpdateStreamRequest = /** @class */ (function () {
    /**
     * Create a new CreateUpdateStreamRequest instance
     *
     * @param path  the topic path
     * @param topicType  the topic type
     * @param constraint  the update constraint
     */
    function CreateUpdateStreamRequest(path, topicType, constraint) {
        this.path = path;
        this.topicType = topicType;
        this.constraint = constraint;
    }
    return CreateUpdateStreamRequest;
}());
exports.CreateUpdateStreamRequest = CreateUpdateStreamRequest;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/topic-update/create-update-stream-request.js
// module id = 1419
// module chunks = 1